var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-field", [
    _c(
      "p",
      { staticClass: "control" },
      [
        _c(
          "b-button",
          {
            attrs: { "icon-left": "save", disabled: _vm.profiles.length === 0 },
            on: { click: _vm.saveProfile },
          },
          [_vm._v(" " + _vm._s(_vm.$t("global.save_grid")) + " ")]
        ),
      ],
      1
    ),
    _c("p", { staticClass: "control" }, [
      _c("span", { staticClass: "button is-static" }, [
        _vm._v(
          _vm._s(_vm.selectedProfile ? _vm.selectedProfile.profileName : "None")
        ),
      ]),
    ]),
    _c(
      "p",
      { staticClass: "control" },
      [
        _c(
          "b-dropdown",
          { ref: "gridDropdown" },
          [
            _c("b-button", {
              attrs: { slot: "trigger", "icon-left": "chevron-down" },
              slot: "trigger",
            }),
            _c(
              "b-dropdown-item",
              {
                attrs: {
                  "aria-role": "menu-item",
                  focusable: false,
                  custom: "",
                  paddingless: "",
                },
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isEditing,
                        expression: "!isEditing",
                      },
                    ],
                    staticClass: "modal-card",
                    staticStyle: { width: "300px" },
                  },
                  [
                    _c("header", { staticClass: "modal-card-head" }, [
                      _vm._v(" COLUMNS VIEWS "),
                    ]),
                    _c(
                      "section",
                      { staticClass: "modal-card-body is-paddingless" },
                      [
                        _c("b-menu", [
                          _vm.profiles.length
                            ? _c(
                                "ul",
                                { staticClass: "menu-list" },
                                _vm._l(_vm.profiles, function (profile) {
                                  return _c(
                                    "li",
                                    { key: profile.profileNamef },
                                    [
                                      _c(
                                        "a",
                                        {
                                          class: {
                                            "is-active":
                                              _vm.activeProfile &&
                                              profile.profileName ===
                                                _vm.activeProfile.profileName,
                                          },
                                          on: {
                                            click: function ($event) {
                                              if (
                                                $event.target !==
                                                $event.currentTarget
                                              )
                                                return null
                                              return _vm.setActive(profile)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(profile.profileName) +
                                              " "
                                          ),
                                          _c("b-icon", {
                                            staticClass: "is-pulled-right",
                                            attrs: { icon: "cog" },
                                            nativeOn: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.setEditing(profile)
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                }),
                                0
                              )
                            : _c("p", [_vm._v(" No profiles yet ")]),
                        ]),
                      ],
                      1
                    ),
                    _c("footer", { staticClass: "modal-card-foot" }, [
                      _c(
                        "div",
                        { staticClass: "buttons" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { "icon-left": "plus" },
                              on: { click: _vm.newProfile },
                            },
                            [_vm._v(" New Profile ")]
                          ),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                type: "is-primary",
                                "icon-left": "check",
                              },
                              on: { click: _vm.validate },
                            },
                            [_vm._v(" Validate ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isEditing,
                        expression: "isEditing",
                      },
                    ],
                    staticClass: "modal-card",
                    staticStyle: { width: "300px" },
                  },
                  [
                    _c(
                      "header",
                      { staticClass: "modal-card-head" },
                      [
                        _c(
                          "b-field",
                          [
                            _c("b-input", {
                              model: {
                                value: _vm.editingProfile.newProfileName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.editingProfile,
                                    "newProfileName",
                                    $$v
                                  )
                                },
                                expression: "editingProfile.newProfileName",
                              },
                            }),
                            _c(
                              "p",
                              { staticClass: "control" },
                              [
                                _c("b-button", {
                                  attrs: {
                                    type: "is-primary",
                                    "icon-left": "save",
                                  },
                                  on: { click: _vm.updateProfile },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "p",
                              { staticClass: "control" },
                              [
                                _c("b-button", {
                                  attrs: {
                                    type: "is-danger",
                                    "icon-left": "trash",
                                  },
                                  on: { click: _vm.deleteProfile },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("section", {
                      staticClass: "modal-card-body is-paddingless",
                    }),
                    _c(
                      "footer",
                      { staticClass: "modal-card-foot" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { "icon-left": "check", type: "is-primary" },
                            on: {
                              click: function ($event) {
                                _vm.isEditing = false
                              },
                            },
                          },
                          [_vm._v(" Done ")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }